class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.debouncedSubmit = this.debounce(() => {
        this.submitForm();
      }, 500);

      this.setupEventListeners();
      this.initializePriceRanges();
      this.setupMobileFilters();
    }

    setupEventListeners() {
      const sortSelect = this.querySelector('#SortBy');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => this.submitForm());
      }

      this.querySelectorAll('[data-facet-checkbox]').forEach((checkbox) => {
        checkbox.addEventListener('change', () => this.submitForm());
      });

      this.querySelectorAll('.facets__price .field__input').forEach((input) => {
        input.addEventListener('change', () => this.submitForm());

        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.submitForm();
          }
        });
      });

      // Links de remoção de filtros
      this.querySelectorAll('[data-facet-remove]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = link.href;
        });
      });

      // Limpar todos
      const clearAll = this.querySelector('[data-clear-all]');
      if (clearAll) {
        clearAll.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = clearAll.href;
        });
      }

      // Botão fechar (mobile)
      const closeBtn = this.querySelector('[data-close-filters]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closeMobileFilters());
      }
    }

    setupMobileFilters() {
      // evita anexar duas vezes se o componente for re-renderizado
      if (window.__facetsMobileDelegationBound) return;
      window.__facetsMobileDelegationBound = true;

      document.addEventListener('click', (e) => {
        const trigger = e.target.closest(
          '.mobile-filter-trigger, #mobile-filter-trigger, .js-filter-trigger, [data-open-filters]'
        );
        if (!trigger) return;

        e.preventDefault();
        console.log('[facets] trigger clicado');

        // tenta achar o drawer mais "próximo" do botão (mais confiável)
        const container = trigger.closest('.facets-container') || document.querySelector('.facets-container');

        const wrapper = container
          ? container.querySelector('.facets__wrapper')
          : document.querySelector('.facets__wrapper');
        const overlay = document.getElementById('facets-overlay');

        if (!wrapper) {
          console.warn('[facets] Não achei .facets__wrapper na página');
          return;
        }

        wrapper.classList.add('is-active');
        if (overlay) overlay.style.display = 'block';
        document.body.classList.add('overflow-hidden');
      });

      // fechar clicando no overlay (delegation também)
      document.addEventListener('click', (e) => {
        if (e.target && e.target.id === 'facets-overlay') {
          this.closeMobileFilters();
        }
      });
    }

    closeMobileFilters() {
      const wrapper = this.querySelector('.facets__wrapper');
      const overlay = document.getElementById('facets-overlay');

      if (wrapper) wrapper.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden');
      if (overlay) overlay.style.display = 'none';
    }

    initializePriceRanges() {
      this.querySelectorAll('[data-price-range]').forEach((priceRange) => {
        const minInput = priceRange.querySelector('[data-range-min]');
        const maxInput = priceRange.querySelector('[data-range-max]');
        const minHidden = priceRange.querySelector('[data-price-min-hidden]');
        const maxHidden = priceRange.querySelector('[data-price-max-hidden]');
        const track = priceRange.querySelector('[data-range-track]');
        const minBubble = priceRange.querySelector('[data-value-min]');
        const maxBubble = priceRange.querySelector('[data-value-max]');
        const applyBtn = priceRange.querySelector('[data-price-apply]');
        const clearBtn = priceRange.querySelector('[data-price-clear]');

        if (!minInput || !maxInput) return;

        const rangeMax = parseInt(minInput.getAttribute('data-range-max-value'));

        const formatPrice = (cents) => {
          return (cents / 100).toFixed(2);
        };

        const updateTrack = () => {
          let min = parseInt(minInput.value);
          let max = parseInt(maxInput.value);

          // Prevenir sobreposição
          if (min > max - 100) {
            min = max - 100;
            minInput.value = min;
          }
          if (max < min + 100) {
            max = min + 100;
            maxInput.value = max;
          }

          const minPercent = (min / rangeMax) * 100;
          const maxPercent = (max / rangeMax) * 100;

          track.style.left = minPercent + '%';
          track.style.width = maxPercent - minPercent + '%';

          minBubble.textContent = formatPrice(min);
          maxBubble.textContent = formatPrice(max);
        };

        minInput.addEventListener('input', updateTrack);
        maxInput.addEventListener('input', updateTrack);

        // Aplicar filtro de preço
        applyBtn.addEventListener('click', () => {
          const minValue = parseInt(minInput.value);
          const maxValue = parseInt(maxInput.value);

          console.log('Aplicando filtro de preço:', { minValue, maxValue });

          // Atualizar os hidden inputs - VALORES EM CENTAVOS
          if (minValue > 0) {
            minHidden.value = minValue;
          } else {
            minHidden.value = '';
          }

          if (maxValue < rangeMax) {
            maxHidden.value = maxValue;
          } else {
            maxHidden.value = '';
          }

          this.submitForm();
        });

        // Limpar filtro de preço
        clearBtn.addEventListener('click', () => {
          minInput.value = 0;
          maxInput.value = rangeMax;
          minHidden.value = '';
          maxHidden.value = '';
          updateTrack();

          // Remover parâmetros de preço da URL e recarregar
          const url = new URL(window.location.href);
          const minParamName = minHidden.name;
          const maxParamName = maxHidden.name;
          url.searchParams.delete(minParamName);
          url.searchParams.delete(maxParamName);
          window.location.href = url.toString();
        });

        updateTrack();
      });
    }

    submitForm() {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams();

      // Processar todos os campos do formulário
      for (let [key, value] of formData.entries()) {
        if (value && value !== '') {
          searchParams.append(key, value);
        }
      }

      // Mostrar loading
      const loading = document.getElementById('facets-loading');
      if (loading) loading.style.display = 'flex';

      // Atualizar URL e recarregar
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
    }

    debounce(fn, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  }

  customElements.define('facet-filters-form', FacetFiltersForm);

  // Custom element para remoção de facetas
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const link = this.querySelector('a');
      if (link) {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const loading = document.getElementById('facets-loading');
          if (loading) loading.style.display = 'flex';
          window.location.href = link.href;
        });
      }
    }
  }

  customElements.define('facet-remove', FacetRemove);

  // Custom element para price range
  class PriceRange extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('price-range', PriceRange);